import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard/forms')({
  component: FormsLayoutRoute,
});

function FormsLayoutRoute() {
  return <Outlet />;
}
